import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { interpolateToJsx } from 'helpers/interpolate'; // Takes a FormattedMessage style "Hello {name}" and munges it to
// "Hello $name" so it can work with the `interpolate` helper

var makeInterpolatable = function makeInterpolatable(message) {
  return (message || '').replace(/\{([a-zA-Z]+)\}/g, '$$$1');
};

export var ConsentMessage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ConsentMessage, _PureComponent);

  function ConsentMessage() {
    _classCallCheck(this, ConsentMessage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConsentMessage).apply(this, arguments));
  }

  _createClass(ConsentMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          message = _this$props.message;
      return React.createElement("p", {
        className: className
      }, interpolateToJsx(makeInterpolatable(message), {
        $linkCookies: React.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "/privacy#cookies"
        }, React.createElement(FormattedMessage, {
          id: "signup.consent.terms",
          defaultMessage: "Cookie Policy"
        })),
        $linkPrivacy: React.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "/privacy"
        }, React.createElement(FormattedMessage, {
          id: "signup.consent.privacy",
          defaultMessage: "Privacy Policy"
        })),
        $linkTerms: React.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: "/terms"
        }, React.createElement(FormattedMessage, {
          id: "signup.consent.cookies",
          defaultMessage: "Terms of Use"
        }))
      }));
    }
  }]);

  return ConsentMessage;
}(PureComponent);
ConsentMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired
};